import { render, staticRenderFns } from "./notice_detail.vue?vue&type=template&id=0cff902a&scoped=true&"
import script from "./notice_detail.vue?vue&type=script&lang=js&"
export * from "./notice_detail.vue?vue&type=script&lang=js&"
import style0 from "./notice_detail.vue?vue&type=style&index=0&id=0cff902a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff902a",
  null
  
)

export default component.exports